import { render, staticRenderFns } from "./Publipostage.vue?vue&type=template&id=5dc91d42"
import script from "./Publipostage.vue?vue&type=script&lang=js"
export * from "./Publipostage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports